import { render } from "./PokemonDetails.vue?vue&type=template&id=246b172a&scoped=true&bindings={\"pokemonId\":\"props\",\"pokemon\":\"data\",\"sprites\":\"data\",\"moves\":\"data\",\"pokemonName\":\"data\",\"pokemonType\":\"data\",\"getPokemon\":\"options\",\"capitalize\":\"options\",\"setPokemonType\":\"options\"}"
import script from "./PokemonDetails.vue?vue&type=script&lang=js"
export * from "./PokemonDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-246b172a"

export default script